import PropTypes from 'prop-types';
import React from 'react';
import {
  TYPE_KAPHA,
  TYPE_PITTA,
  TYPE_VATA,
} from '../../data/types';
import styles from '../../styles/main.scss';

const SummaryComponent = (props) => (
  <div>
    <h2 className="h2-alt">
      Výsledky ajurvédskeho dóšického testu
    </h2>
    <div className="offset-bottom">
      <p>
        Ajurvédsky dóšický test je na konci. Nižšie nájdete pomery dóš na
základe vyplneného&nbsp;testu.
      </p>
      <p>
        {
          Object.entries(props.answersStatistics)
            .sort((a, b) => b[1] - a[1])
            .map(([type, value], index) => {
              const percentage = ((value / props.questionCount) * 100).toFixed(1);
              let typeLabel = '-';

              if (type === TYPE_KAPHA) {
                typeLabel = 'Kapha';
              } else if (type === TYPE_PITTA) {
                typeLabel = 'Pitta';
              } else if (type === TYPE_VATA) {
                typeLabel = 'Váta';
              }

              return (
                <span
                  className={styles[`dos${index + 1}`]}
                  key={type}
                >
                  {typeLabel}: {percentage}%<br />
                </span>
              );
            })
        }
      </p>
      <p>
        Každý človek sa rodí s&nbsp;jedinečným pomerom troch dóš <em>(vata, pitta,
        kapha)</em>, ktoré sú kombináciou piatich elementov prírody (éteru, vzduchu,
        ohňa, vody, zeme). <em>Vata</em> je tvorená spojením vzduchu a éteru. <em>Pitta </em>
        predstavuje oheň s&nbsp;vodou a <em>kapha</em> je utváraná zložením vody a zeme.
        V&nbsp;priebehu života sa z&nbsp;mnohých príčin pomerné zastúpenie jednotlivých
        dóš vychyľuje <em>(vikriti)</em> zo svojho pôvodne vrodeného stavu <em>(prakriti)</em>. Ak
        vám vyjde dominantná prevaha charakteristiky pitta, potom ste pitta typ.
        V&nbsp;prípade, že vám vyjde podobné zastúpenie dvoch dóš potom ste
        kombinovaný typ. Napriek tomu však aj v&nbsp;tomto prípade je vždy jedna
        z&nbsp;dóš výraznejšia a preto bude silnejšie ovplyvňovať vašu nerovnováhu.
        Vyvážený typ vata, pitta, kapha je veľmi vzácnou výnimkou.
      </p>

      <p>
        Odporúčania pre obnovenie rovnováhy nájdete nižšie v texte.
      </p>

    </div>
    <button
      className="btn btn-default"
      onClick={props.onResetClick}
    >
      Spustit test znovu
    </button>
  </div>
);

SummaryComponent.propTypes = {
  answersStatistics: PropTypes.shape({}).isRequired,
  onResetClick: PropTypes.func.isRequired,
  questionCount: PropTypes.number.isRequired,
};

export default SummaryComponent;
